import { MaterialIcons } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation, useRoute } from "@react-navigation/core";
import React, { useEffect, useState } from "react";
import { Image, Modal, Text, TouchableOpacity, View } from "react-native";
import AuthCodeInput from "../../components/Form/AuthCodeInput";
import binanceService from "../../services/binanceService";
import { styles } from "./styles";
import ConfirmEmail from "../../components/ConfirmEmail/ConfirmEmail";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";

const WithdrawCryptoPassword = () => {
  const navigation = useNavigation();
  const route = useRoute();

  const [password, setPassword] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  const [crypto, setCrypto] = useState(route.params.crypto);
  const [value, setValue] = useState(route.params.value);
  const [wallet, setWallet] = useState(route.params.wallet);

  const [emailCode, setEmailCode] = useState();
  const [emailVerified, setEmailVerified] = useState(false);

  useEffect(() => {
    if (password.length === 6 && emailVerified === true) {
      transfer();
    }
  }, [password, emailCode]);

  function onModalClose() {
    setModalVisible(false);
    navigation.navigate("Home");
  }

  const intl = useIntl();
  const transfer = async () => {
    try {
      const authToken = await AsyncStorage.getItem("JWT_TOKEN");
      const { data } = await binanceService.registerCashOutTransaction(
        authToken,
        crypto.activeId,
        value,
        wallet,
        password
      );
      setModalVisible(true);
    } catch (err) {
      if (err.response.data?.message) {
        alert(err.response.data?.message);
      } else {
        alert(intl.formatMessage({ id: "withdrawcryptopassword.houveErro" }));
      }
    }
  };

  return (
    <>
      <View style={{ flex: 1 }}>
        <HeaderTabs
          title={
            <FormattedMessage id="withdrawcryptopassword.confirmarSaque" />
          }
          subtitle={"Alterar Depois"}
        />

        <View style={styles.container}>
          <View>
            <AuthCodeInput
              cellCount={6}
              isPassword={true}
              value={password}
              onValueChange={(value) => setPassword(value)}
              label={
                <FormattedMessage id="withdrawcryptopassword.digiteSenha" />
              }
            />
          </View>
          <ConfirmEmail
            onChange={(value) => setEmailCode(value)}
            onVerified={(value) => setEmailVerified(value)}
          />
        </View>
      </View>
      <Modal
        animationType="slide"
        visible={modalVisible}
        presentationStyle="fullscreen"
        onRequestClose={onModalClose}
        style={styles.modal}
      >
        <View style={styles.modalContainer}>
          <TouchableOpacity onPress={onModalClose} style={styles.modalClose}>
            <MaterialIcons name="close" size={30} color="black" />
          </TouchableOpacity>
          <Image
            style={styles.modalSuccess}
            source={require("../../../assets/success.png")}
          ></Image>
          <Text style={styles.modalText}>
            <FormattedMessage id="withdrawcryptopassword.saqueEnviado" />
            {"\n"}
            <FormattedMessage id="withdrawcryptopassword.emBreve" />
          </Text>
          <Text style={styles.modalText}>
            <FormattedMessage id="withdrawcryptopassword.deveAguardar" />
            {"\n"}
            <FormattedMessage id="withdrawcryptopassword.processarTransacao" />
          </Text>
          {/* <Text style={styles.modalText}>
            O código da transação é:{'\n'}
            <Text style={styles.textBold}>txId{'\n'}{txId}</Text>
          </Text> */}
          {/* <TouchableOpacity onPress={copyTxId}>
            <Text style={styles.copyText}>{copied ? "Copiado!" : "Copiar código"}</Text>
          </TouchableOpacity> */}
          <Image
            resizeMode="contain"
            style={styles.modalImage}
            source={require("../../../assets/imgs/cardCoin.png")}
          />
        </View>
      </Modal>
    </>
  );
};

export default WithdrawCryptoPassword;
